import React from 'react'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import TextProgress from 'components/Submissions/Review/common/TextProgress'
import { ProgressContainer } from './style'
import { useNewTranslation } from 'hooks/index'
import './Progress.css'
import Tooltip from 'particles/Tooltip'

interface ProgressProps {
    completedSlotCount?: number
    totalSlotCount?: number
}

const Progress: React.FC<ProgressProps> = ({ completedSlotCount, totalSlotCount }) => {
    const [t] = useNewTranslation()
    const progress =
        typeof completedSlotCount === 'number' && typeof totalSlotCount === 'number' && totalSlotCount > 0
            ? completedSlotCount >= totalSlotCount
                ? 100
                : (completedSlotCount / totalSlotCount) * 100
            : undefined
    return typeof progress === 'number' ? (
        <ProgressContainer>
            <TextProgress
                completedSlot={t('statusLabel.completedCount', { count: completedSlotCount })}
                totalSlot={t('statusLabel.campaignSlotCount', { count: totalSlotCount })}
            />
            <Tooltip
                title={t('submission.allSubmission.campaignCompletionTooltipTitle')}
                label={t('submission.allSubmission.campaignCompletionTooltipDescription')}
            >
                <Box className="progress-container">
                    <LinearProgress
                        classes={{ bar: 'progressbar' }}
                        className="linear-progress"
                        variant="determinate"
                        value={progress}
                    />
                </Box>
            </Tooltip>
        </ProgressContainer>
    ) : null
}

export default Progress
